<!-- eslint-disable max-len -->
<template>
  <div>
    <div
      id="dual-sidebar-page-studio"
      :class="isSidebarMinimized ? 'dual-sidebar-page-studio__open' : 'dual-sidebar-page-studio__closed'">
      <div
        id="menus"
        class="menus menu-box-shadow">
        <img
          :src="require(`@/assets/icon-sidebar/minimize${!isSidebarMinimized ? '-two' : ''}.png`)"
          class="img-minimize"
          height="35"
          @click="expandSidebar">
        <div class="sidebar__nav--container">
          <div
            :class="isSidebarMinimized ? 'display-show' : 'display-hide'"
            class="label-top">APPLICATION & UI BUILDER</div>
          <div :class="!isSidebarMinimized ? 'separator-show m__t--10' : 'separator-hide'" />
          <transition name="slide-left">
            <ul
              class="sidebar-nav">
              <li
                v-for="(menu, index) in menusUi"
                :key="'nested' + index"
                class="menus-list">
                <j-nested-menu
                  :menu="menu"
                  :minimized="isSidebarMinimized"/>
              </li>
            </ul>
          </transition>
          <div
            :class="isSidebarMinimized ? 'display-show' : 'display-hide'"
            class="label-top">DATABASE & CONNECTIVITY</div>
          <div :class="!isSidebarMinimized ? 'separator-show m__t--25' : 'separator-hide'" />
          <transition name="slide-left">
            <ul
              v-show="menu"
              class="sidebar-nav">
              <li
                v-for="(menu, index) in menusDatabase"
                :key="'nested' + index"
                class="menus-list">
                <j-nested-menu
                  :menu="menu"
                  :minimized="isSidebarMinimized"/>
              </li>
            </ul>
          </transition>
          <div
            :class="isSidebarMinimized ? 'display-show' : 'display-hide'"
            class="label-top">LOGIC & INTELLIGENCE</div>
          <div :class="!isSidebarMinimized ? 'separator-show m__t--25' : 'separator-hide'" />
          <transition name="slide-left">
            <ul
              v-show="menu"
              class="sidebar-nav">
              <li
                v-for="(menu, index) in menusLogic"
                :key="'nested' + index"
                class="menus-list">
                <j-nested-menu
                  :menu="menu"
                  :minimized="isSidebarMinimized"/>
              </li>
            </ul>
          </transition>
          <div
            :class="isSidebarMinimized ? 'display-show' : 'display-hide'"
            class="label-top">SETTINGS</div>
          <div :class="!isSidebarMinimized ? 'separator-show m__t--25' : 'separator-hide'" />
          <transition name="slide-left">
            <ul
              v-show="menu"
              class="sidebar-nav">
              <li
                v-for="(menu, index) in menusOther"
                :key="'nested' + index"
                class="menus-list">
                <j-nested-menu
                  :menu="menu"
                  :minimized="isSidebarMinimized"/>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved,vue/require-default-prop */
import { mapMutations, mapState } from 'vuex';
import jNestedMenu from './jNestedMenu';
import jMenuProducts from './jMenuProducts';

export default {
  name: 'JDualSidebarSetting',
  components: {
    jNestedMenu, jMenuProducts,
  },
  props: {
    productsItems: Array,
    groupProducts: {
      type: Array,
      default: () => [],
    },
    menusUi: Array,
    menusDatabase: Array,
    menusLogic: Array,
    menusOther: Array,
    logo: String,
    responsiveLogo: String,
    isSidebarOpen: Boolean,
  },
  /**
     * menu: is menu displayed?
     * menuProduct: is menuProduct displayed?
     * @returns {{menu: boolean, menuProduct: boolean}}
     */
  data() {
    return {
      menu: true,
      menuProduct: false,
      menuApplication: [],
      appName: null,
      isSidebarMinimized: true,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },

  watch: {
    is_sidebar_minimized(val) {
      this.isSidebarMinimized = val;
    },

    appName(val) {
      this.groupProducts.filter(group =>
        group.applications.some(app => app.name.toUpperCase().includes(val.toUpperCase())));

      this.groupProducts.forEach((group) => {
        // eslint-disable-next-line
        group.apps = group.applications
          .filter(app => app.name.toUpperCase().includes(val.toUpperCase()));
      });
    },
  },
  methods: {
    ...mapMutations('jStoreSetting', ['setSidebarMinimized']),

    openSidebar() {
      this.$emit('toggle-sidebar', true);
    },
    closeSidebar() {
      this.$emit('toggle-sidebar', false);
    },
    openProduct(item) {
      if (item.href) {
        this.$router.push(item.href);
      } else {
        window.location.href = item.hrefout;
      }
    },
    checkUrl(item) {
      if (item.href) {
        if (item.isShow && item.href.includes('http')) {
          return true;
        }
      }
      return false;
    },
    expandSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized;
      this.setSidebarMinimized(this.isSidebarMinimized);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sidebar/jDualSidebarSetting.vue